import { ITeleopLayout } from "@formant/core/model/ITeleopLayout";

export const setHero = (
    layout: ITeleopLayout,
    streamName: string,
    save: (l: ITeleopLayout) => void,
) => {
    Object.keys(layout).forEach((_: string) => {
        const { configuration } = layout[_];
        const toggle = !configuration?.useAsPrimaryStream;
        layout[_].configuration = {
            ...configuration,
            useAsPrimaryStream: _ === streamName ? toggle : false,
        };
    });
    save(layout);
};

export const getHero = (layout: ITeleopLayout): string => {
    const [hero] = Object.keys(layout).filter(
        l =>
            !!layout[l]?.configuration &&
            layout[l].configuration?.useAsPrimaryStream,
    );
    return hero;
};

export const moduleHasClearBackground = (
    layout: any,
    moduleName: string,
): boolean => {
    return layout[moduleName]?.configuration?.clearBackground || false;
};

export const toggleClearBackground = (
    layout: any,
    moduleName: string,
    save: (layout: ITeleopLayout) => void,
) => {
    const { configuration } = layout[moduleName];
    const toggle = !configuration?.clearBackground;
    layout[moduleName].configuration = {
        ...configuration,
        clearBackground: toggle,
    };
    save(layout);
};

export const isFixed = (layout: any, moduleName: string): boolean => {
    const fixed = layout[moduleName]?.static || false;
    return fixed;
};

export const toggleFixed = async (
    layout: any,
    moduleName: string,
    fixed: boolean,
    save: (layout: ITeleopLayout) => void,
) => {
    layout[moduleName] = {
        ...layout[moduleName],
        static: fixed,
    };
    save(layout);
};
